<template>
  <div class="page">
    <navigation adaption />
    <div class="header">
      <span class="back" @click="backHome">返回首页</span>
    </div>
    <div class="content">
      <img src="./image/icon_status_refused_pass.png">
      <div class="desc">资方放款失败</div>
      <p>放款被拒2-7个工作日内自动退款</p>
      <nd-button class="rematch" @click="rematch" v-if="showReApplay">重新匹配资方放款</nd-button>
      <div class="use-privilege" @click="usePrivilege">去退款</div>
      <call-service-button
        class="service"
        @onCall="openServiceDialog"
      />
    </div>
    <service-jw
      v-model="customerShow"
      :description="`未匹配到优质资方，暂时无法发起提现`"
    />
    <nd-dialog
      v-model="popVisible"
      closeBtn
      :footer="false"
    >
      <div class="pop-dialog">
        <div class="title">提现绿色通道</div>
        <div class="description">已为您匹配到更多资方，提现成功率提升5倍</div>
        <div class="button-group">
          <nd-button class="continue-btn" @click="goWithdraw">继续提现</nd-button>
          <div class="giveup-btn" @click="backHome">放弃</div>
        </div>
      </div>
    </nd-dialog>
  </div>
</template>

<script>
import { getKey, mockHrefJump, judgeClientSystem } from '@/assets/utils'
import { hasNativeMethod, jsBridge } from '@/assets/jsBridge'
import { mapActions } from 'vuex'
import callServiceButton from '@/components/service-button'
export default {
  data () {
    return {
      customerShow: false,
      popVisible: false,
      showReApplay: false
    }
  },
  components: {
    callServiceButton,
    serviceJw: () => import('@/components/service-jw')
  },
  async created () {
    await this.getLoanResult()
    this.$bus.$emit('ready')
  },
  methods: {
    ...mapActions('withdraw', ['getLoanResultX']),
    backHome () {
      if (hasNativeMethod('navigateTo') && judgeClientSystem() !== 'IOS') {
        jsBridge('exit')
      } else {
        this.$router.push('/')
      }
    },
    rematch () {
      // 跳转pass卡提现页
      this.$router.push('/withdraw/passcard')
    },
    usePrivilege () {
      // 跳转pass卡详情页
      const origin = process.env.VUE_APP_PAYURL
      const gid = localStorage.getItem('gid')
      const token = getKey('userInfo', 'token') || ''
      const data = `gid=${gid}&token=${token}`
      window.location.href = `${origin}/vip/pass?${data}&refurl=${window.location.origin}`
    },
    openServiceDialog () {
      // 呼叫客服
      this.customerShow = true
    },
    // 关闭客服电话
    closeServiceDialog () {
      this.customerShow = false
    },
    callService () {
      mockHrefJump(`tel:4000100008`)
    },
    async getLoanResult () {
      const response = await this.getLoanResultX({ loanApplyNo: this.$route.query.loanApplyNo })
      const { success, data } = response
      if (success) {
        this.popVisible = data.pop36
        this.showReApplay = !(data.passCardProcess === 'Y' && data.loanStatusVoEnum === 'WITHDRAWALS_REJECTED')
      }
    },
    goWithdraw () {
      this.$router.push('/middle/limit')
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.page {
  background: #FFF;
  display: flex;
  flex-direction: column;
  .back {
    float: right;
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    text-decoration: underline;
    text-align: right;
    padding:30px
  }
  .content {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    p {
      font-size: 24px;
      margin-top: 10px;
    }
    .desc {
      font-size: 42px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 59px;
      margin-top: 20px;
    }
    .rematch {
      width: 360px;
      height: 80px;
      margin-top: 50px;
      line-height: 80px;
    }
    .use-privilege {
      width: 360px;
      height: 80px;
      border-radius: 40px;
      border: 2px solid #FF4633;
      font-size: 32px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #FF4633;
      line-height: 80px;
      text-align: center;
      margin-top: 30px;
    }
    .service {
      margin-top: 70px;
    }
  }
  .pop-dialog{
    padding: 35px;
    .title{
      font-size: 40px;
      font-weight: bold;
      text-align: center;
    }
    .description{
      font-size: 28px;
      margin-top: 30px;
    }
    .button-group{
      margin-top: 50px;
      text-align: center;
      .continue-btn{
        width: 340px;
        margin: 0 auto;
      }
      .giveup-btn{
        display: inline-block;
        font-size: 30px;
        margin-top: 30px;
      }
    }
  }
}
</style>